import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
// import { NgbTabset, NgbTabsetConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbNav, NgbNavConfig } from '@ng-bootstrap/ng-bootstrap';
import { ColumnChooserService, GridComponent, PageService, ToolbarService, VirtualScrollService } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations/src';
import { ToastrService } from 'ngx-toastr';
import { fadeInOut } from '../../shared/helpers/animations';
import { ICompanyContactStatus, IContact } from '../../shared/models/index';
import { AuthorizationService, CompanyContactService, StorageManagerService } from '../../shared/services/index';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { DeleteButtonComponent } from '../common/delete-button/delete-button.component';
import { Utilities } from '../../shared/services/utilities';

@Component({
    selector: 'app-contact-dashboard',
    templateUrl: './contact-dashboard.component.html',
    styleUrls: ['./contact-dashboard.component.scss'],
    providers: [ToolbarService, ColumnChooserService, PageService, VirtualScrollService],
    animations: [fadeInOut],
    standalone: false
})

export class ContactDashboardComponent implements OnInit {

  @ViewChild('contact_grid')
  public contactGrid: GridComponent;
  @ViewChild('drafts_grid')
  public draftsGrid: GridComponent;
  @ViewChild('ngbNav', { static: true })
  public tabset: NgbNav;
  @ViewChild('tooltip')
  public tooltip: TooltipComponent;
  @ViewChild('deleteContact')
  public deleteButton: DeleteButtonComponent;
  @ViewChild('deleteDraftContact')
  public deleteButtonDrafts: DeleteButtonComponent;

  @Input() drafts_grid_data: IContact[];
  @Input() contact_grid_data: IContact[];
  public initialPage: Object;
  public toolbarOptions: Object;
  errorMessage: string;
  count_contact: number;
  count_drafts: number;
  FORM_STATUS_ACTIVE = 'A';
  contactStatus: ICompanyContactStatus;
  loading = true;
  public formatOptions: any;
  activeTab: string;
  sub: Subscription;
  public clipmodecolumn = { class: 'e-tooltipcolumn' };
  selectedContactRevisionId: number | undefined;
  hasWritePermission = false;
  hasDeletePermission = false;

  constructor(private router: Router, private companySvc: CompanyContactService, private toastr: ToastrService,
    private sanitizer: DomSanitizer, private storageManagerService: StorageManagerService, private authorizationService: AuthorizationService) {
  }

    ngOnInit(): void {
        this.checkUserPermission();

        this.toolbarOptions = this.createCustomToolbarItems(this.hasDeletePermission, this.hasWritePermission);

        this.initialPage = { currentPage: 1, pageSize: 25, pageSizes: [25, 50, 75, 100, 'All'] };
        this.formatOptions = { type: 'dateTime', format: Utilities.getLocaleDateString() + ' hh:mm a' };

        // clear out previously saved info
        sessionStorage['currentContactId'] = null;

      // set focus on the invisible div so the firest tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
      this.initTabIndex();

      this.getContacts();

      this.activeTab = 'contact';

      // Fix for footer spacing issues
      document.getElementsByTagName('footer')[0].classList.add("footer-spacing-fix");
    }

    initTabIndex() {
      (document.activeElement as HTMLElement).blur();

      const main = document.getElementById('firstDiv');

      if (main) {
        main.focus();
      }
    }

    createCustomToolbarItems(deletePermission : boolean, writePermission: boolean) {
        let toolbarItems = [];

        if (writePermission) {
            toolbarItems.push(
                {
                    text: 'Create New Contact',
                    tooltipText: 'Add a new contact to this list',
                    prefixIcon: 'fas fa-plus',
                    id: 'create-form-btn'
                }
            );
        }

        if(deletePermission){
            toolbarItems.push(
                {
                    text: 'Delete Contact',
                    tooltipText: 'Delete the selected contact',
                    prefixIcon: 'fas fa-trash',
                    id: 'tool-bar-delete'
                }
            )
        }

        toolbarItems.push('Search');

        return toolbarItems;
      }

    checkUserPermission() {
        if (this.authorizationService.hasPermission('SSDP.CanWriteContact')) {
          this.hasWritePermission = true;
        }
        if (this.authorizationService.hasPermission('SSDP.CanDeleteContact')) {
            this.hasDeletePermission = true;
        }
    }

    tabChanged(event) {
      this.activeTab = event.nextId;
      this.selectedContactRevisionId = undefined;
  }

  tooltipValue(args) {

    let grid;

    if (args.target.scrollWidth <= args.target.clientWidth) {
      args.cancel = true;
    } else {

      switch (this.activeTab) {
        case 'drafts':
          grid = this.draftsGrid;
          break;
        case 'contact':
          grid = this.contactGrid;
          break;
      }

      const rowInfo = grid.getRowInfo(args.target);
      const rowData = rowInfo.rowData;
      this.tooltip.cssClass = 'customTooltip';
      this.tooltip.content = rowData[(rowInfo.column as any).field];
    }
  }

    // Grid toolbar click event handler
    toolbarClick(args: ClickEventArgs): void {
        if (args.item.id === 'create-form-btn') {
            this.router.navigate(['contact']);
        }
        if (args.item.id === 'tool-bar-delete' && this.selectedContactRevisionId) {
            if(this.contactGrid){
                this.deleteButton.revisionId = this.selectedContactRevisionId.toString();
                this.deleteButton.openDeleteModal();
            }
            else if(this.draftsGrid){
                this.deleteButtonDrafts.revisionId = this.selectedContactRevisionId.toString();
                this.deleteButtonDrafts.openDeleteModal();
            }
        }
    }

    // Retrieve a list of contacts
    getContacts() {
        this.companySvc.GetContactDashboard().subscribe(data => {
            if (data && data.length) {
                this.loading = false;

                this.drafts_grid_data = data.filter(p => p.isDraftMode == true);
                this.count_drafts = this.drafts_grid_data.length;

                const mappedData = data.map(d => Object.assign(d, { status$: d.loAFlag ? 'Inactive' : 'Active' }));
                this.contact_grid_data = mappedData.filter(p => p.isDraftMode == false);
                this.count_contact = this.contact_grid_data.length;

            } else {
                this.loading = false; // no data so stop the spinner
            }
        },
            error => {
                this.loading = false;
                this.toastr.error(error && error.errorMessage ? error.errorMessage : error.error);
            }
        );
    }

    // Change grid filter operator from "startwith" to "contains" for columns that are string
  public begin(args: any): void {
    if (args.requestType === 'filtering') {
      if (args.columns) {
        args.columns.forEach(col => {
          switch (args.currentFilteringColumn) {
            case 'version':
              args.currentFilterObject.value = `${ args.currentFilterObject.value }.0`;
              break;
            case 'modified':
              break;
            default:
              col.operator = 'contains';       // set the “contains” operator for the column
              break;
          }
        });
      }
    }
  }

    viewContact(contactRevisionId: string, contactId: string) {
        if (contactRevisionId) {

            this.router.navigate(['contact', contactRevisionId]);
        }
    }

    contactGridRowSelected(e: any){
        this.selectedContactRevisionId = e.data.contactRevisionId;
    }

    contactGridRowDeselected() {
        this.selectedContactRevisionId = undefined;
    }
      
}

